import { Box, Button, Flex, HStack, VStack } from '@chakra-ui/react';
import { PageHeading } from '@duke-hq/ui/components/PageHeading';
import { Settings, Info } from 'lucide-react';
import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { useTenantContext } from '@duke-hq/app-provider-web/tenant/TenantContext';
import { GroupRewardsInfoModal } from './GroupRewardsInfoModal';

export function GroupRewardsPage(): React.ReactElement {
  const tenantCtx = useTenantContext();
  const location = useLocation();
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <Box w="full" h="full" overflow="auto" bg="bg.default" p="16px">
      <VStack align="stretch" width="full" gap={6}>
        <Flex alignItems="center" justify="space-between" gap="8px" mb={4}>
          <PageHeading>
            <Trans>Good Effort Program</Trans>
          </PageHeading>
          <HStack spacing={2}>
            <Button
              key="explainer"
              size="xs"
              leftIcon={<Info size={16} />}
              onClick={() => setIsOpenModal(true)}
            >
              <Trans>Info</Trans>
            </Button>
            {tenantCtx?.permissions.includes('canManageCauses') === true &&
            !location.pathname.includes('/group_rewards/settings') ? (
              <Button
                key="canManageCauses"
                size="xs"
                variant="outline"
                as={Link}
                to={`/group_rewards/settings`}
                leftIcon={<Settings size={16} />}
              >
                <Trans>Admin</Trans>
              </Button>
            ) : null}
          </HStack>
        </Flex>
      </VStack>

      <GroupRewardsInfoModal
        isOpen={isOpenModal}
        onClose={() => {
          setIsOpenModal(!isOpenModal);
        }}
      />
      <Outlet />
    </Box>
  );
}
